const themes = {
  claro: {
    palette: {
      mode: "light",
      primary: {
        main: "#1976d2",
      },
      secondary: {
        main: "#9c27b0",
      },
      background: {
        default: "#f5f5f5",
        paper: "#ffffff",
      },
      text: {
        primary: "#000000",
        secondary: "#333",
      },
      status: {
        pending: "#A5D6A7",
        inProgress: "#FFCA28",
        future: "#82AEF8",
        success: "#388E3C",
        unsuccessful: "#EF5350",
        canceled: "#9575CD",
      },
      messages: {
        client: "#e8ecf0",           // Cinza neutro (mensagens do cliente / BOT)
        clientContrast: "#1c1e21",
        user: "#0b93f6",             // Azul sólido (mensagens do atendente logado)
        userContrast: "#ffffff",
        others: "#d4dce4",          // Cinza azulado mais escuro (outros atendentes – diferenciado do cliente)
        othersContrast: "#1c1e21",
        notes: "#f2f2f2",
      },
    },
  },
  escuro: {
    palette: {
      mode: "dark",
      primary: {
        main: "#90caf9",
      },
      secondary: {
        main: "#f48fb1",
      },
      background: {
        default: "#121212",
        paper: "#1e1e1e",
      },
      text: {
        primary: "#ffffff",
        secondary: "#ccc",
      },
      status: {
        pending: "#81C784",
        inProgress: "#FFB74D",
        future: "#64B5F6",
        success: "#2E7D32",
        unsuccessful: "#E57373",
        canceled: "#AB47BC",
      },
      messages: {
        client: "#3a3f44",           // Cinza neutro (mensagens do cliente / BOT)
        clientContrast: "#e4e6eb",
        user: "#0b93f6",             // Azul sólido (mensagens do atendente)
        userContrast: "#ffffff",
        others: "#4a5568",           // Cinza mais claro (outros atendentes – diferenciado do cliente)
        othersContrast: "#e4e6eb",
        notes: "#2a2a2a",
      },
    },
  },
  vibrante: {
    palette: {
      mode: "light",
      primary: {
        main: "#ff7043",
      },
      secondary: {
        main: "#4fc3f7",
      },
      background: {
        default: "#fefefe",
        paper: "#f5f5f5",
      },
      text: {
        primary: "#2e2e2e",
        secondary: "#5f5f5f",
      },
      status: {
        pending: "#dcedc8",
        inProgress: "#ffe082",
        future: "#b3e5fc",
        success: "#66bb6a",
        unsuccessful: "#ef9a9a",
        canceled: "#d1c4e9",
      },
      messages: {
        client: "#ff7043", // Laranja forte (maior destaque)
        user: "#ff9d78",   // Laranja mais claro
        others: "#ffc2aa", // Laranja muito claro
        notes: "#f8f8f8",  // Cinza claro
      },
    },
  },
  cinzaAzulado: {
    palette: {
      mode: "light",
      primary: {
        main: "#546E7A",
      },
      secondary: {
        main: "#90A4AE",
      },
      background: {
        default: "#CFD8DC",
        paper: "#FFFFFF",
      },
      text: {
        primary: "#263238",
        secondary: "#4E5D6A",
      },
      status: {
        pending: "#90A4AE",
        inProgress: "#FFC107",
        future: "#64B5F6",
        success: "#388E3C",
        unsuccessful: "#D32F2F",
        canceled: "#7E57C2",
      },
      messages: {
        client: "#546E7A", // Cinza azulado escuro (maior destaque)
        user: "#7892a0",   // Cinza azulado mais claro
        others: "#a7c0cf", // Cinza azulado muito claro
        notes: "#f1f3f4",  // Cinza muito suave
      },
    },
  },
  naturezaVerde: {
    palette: {
      mode: "light",
      primary: {
        main: "#6fbf73",
      },
      secondary: {
        main: "#a5d6a7",
      },
      background: {
        default: "#f3f8f2",
        paper: "#ffffff",
      },
      text: {
        primary: "#2e7d32",
        secondary: "#5f5f5f",
      },
      status: {
        pending: "#c8e6c9",
        inProgress: "#fff59d",
        future: "#dce775",
        success: "#43a047",
        unsuccessful: "#e57373",
        canceled: "#ba68c8",
      },
      messages: {
        client: "#6fbf73", // Verde médio (maior destaque)
        user: "#94d296",   // Verde mais claro
        others: "#c1e6c5", // Verde muito claro
        notes: "#eef6ec",  // Verde neutro
      },
    },
  },
  porDoSol: {
    palette: {
      mode: "light",
      primary: {
        main: "#ff8a65",
      },
      secondary: {
        main: "#ffb74d",
      },
      background: {
        default: "#ffe0b2",
        paper: "#ffffff",
      },
      text: {
        primary: "#bf360c",
        secondary: "#5d4037",
      },
      status: {
        pending: "#FFAB91",
        inProgress: "#FFD54F",
        future: "#4FC3F7",
        success: "#AED581",
        unsuccessful: "#F4511E",
        canceled: "#AB47BC",
      },
      messages: {
        client: "#ff8a65", // Laranja vibrante (maior destaque)
        user: "#ffb49d",   // Laranja mais claro
        others: "#ffd4c0", // Laranja muito claro
        notes: "#f8e5d4",  // Bege pastel
      },
    },
  },
  barbie: {
    palette: {
      mode: "light",
      primary: {
        main: "#ec407a",
      },
      secondary: {
        main: "#ffb3c7",
      },
      background: {
        default: "#fff5f9",
        paper: "#fffafc",
      },
      text: {
        primary: "#7b1a5a",
        secondary: "#5c1045",
      },
      status: {
        pending: "#f48fb1",
        inProgress: "#f06292",
        future: "#ce93d8",
        success: "#ec407a",
        unsuccessful: "#e57373",
        canceled: "#ab47bc",
      },
      messages: {
        client: "#ec407a", // Rosa vibrante (maior destaque)
        user: "#f38ab0",   // Rosa mais claro
        others: "#f8bbce", // Rosa muito claro
        notes: "#fbe9e7",  // Bege rosado
      },
    },
  },
  frozen: {
    palette: {
      mode: "light",
      primary: {
        main: "#29b6f6",
      },
      secondary: {
        main: "#bbdefb",
      },
      background: {
        default: "#e1f5fe",
        paper: "#ffffff",
      },
      text: {
        primary: "#0277bd",
        secondary: "#01579b",
      },
      status: {
        pending: "#B3E5FC",
        inProgress: "#81D4FA",
        future: "#4FC3F7",
        success: "#29B6F6",
        unsuccessful: "#E57373",
        canceled: "#7986CB",
      },
      messages: {
        client: "#29b6f6", // Azul vibrante (maior destaque)
        user: "#73cef8",   // Azul mais claro
        others: "#aee7fa", // Azul muito claro
        notes: "#edf8ff",  // Azul claríssimo
      },
    },
  },
  jornadaNasEstrelas: {
    palette: {
      mode: "dark",
      primary: {
        main: "#5c6bc0",
      },
      secondary: {
        main: "#ffd54f",
      },
      background: {
        default: "#121212",
        paper: "#1e1e1e",
      },
      text: {
        primary: "#e0e0e0",
        secondary: "#9e9e9e",
      },
      status: {
        pending: "#9FA8DA",
        inProgress: "#FFD740",
        future: "#64B5F6",
        success: "#81C784",
        unsuccessful: "#EF9A9A",
        canceled: "#CE93D8",
      },
      messages: {
        client: "#5c6bc0", // Azul escuro vibrante (maior destaque)
        user: "#48539e",   // Azul escurecido
        others: "#36427c", // Azul ainda mais escuro
        notes: "#2b2b2b",  // Cinza escuro discreto
      },
    },
  },
  cyberpunk: {
    palette: {
      mode: "dark",
      primary: {
        main: "#ff0090",
      },
      secondary: {
        main: "#00eaff",
      },
      background: {
        default: "#101010",
        paper: "#1b1b1b",
      },
      text: {
        primary: "#e0e0e0",
        secondary: "#a3a3a3",
      },
      status: {
        pending: "#ff80ab",
        inProgress: "#4fc3f7",
        future: "#90caf9",
        success: "#66bb6a",
        unsuccessful: "#ef5350",
        canceled: "#ce93d8",
      },
      messages: {
        client: "#ff0090", // Rosa neon vibrante (maior destaque)
        user: "#cc0070",   // Rosa escurecido
        others: "#990052", // Rosa ainda mais escuro
        notes: "#4c4c4c",  // Cinza moderado
      },
    },
  },
  cafe: {
    palette: {
      mode: "light",
      primary: {
        main: "#6d4c41",
      },
      secondary: {
        main: "#d7ccc8",
      },
      background: {
        default: "#f5f5f5",
        paper: "#ffffff",
      },
      text: {
        primary: "#3e2723",
        secondary: "#5d4037",
      },
      status: {
        pending: "#a1887f",
        inProgress: "#ffe082",
        future: "#bcaaa4",
        success: "#8d6e63",
        unsuccessful: "#ef9a9a",
        canceled: "#ba68c8",
      },
      messages: {
        client: "#6d4c41", // Marrom escuro (maior destaque)
        user: "#99786c",   // Marrom mais claro
        others: "#c2a69a", // Marrom muito claro
        notes: "#f6f4f3",  // Cinza claro suave
      },
    },
  },
  solaris: {
    palette: {
      mode: "light",
      primary: {
        main: "#ffc107",
      },
      secondary: {
        main: "#ff7043",
      },
      background: {
        default: "#fffde7",
        paper: "#ffffff",
      },
      text: {
        primary: "#212121",
        secondary: "#5f5f5f",
      },
      status: {
        pending: "#ffecb3",
        inProgress: "#ffe082",
        future: "#ffcc80",
        success: "#aed581",
        unsuccessful: "#f44336",
        canceled: "#ba68c8",
      },
      messages: {
        client: "#ffc107", // Amarelo vibrante (maior destaque)
        user: "#ffda6a",   // Amarelo mais claro
        others: "#ffe8ad", // Amarelo muito claro
        notes: "#fffae5",  // Bege claríssimo
      },
    },
  },
  minimalista: {
    palette: {
      mode: "light",
      primary: {
        main: "#9e9e9e",
      },
      secondary: {
        main: "#bdbdbd",
      },
      background: {
        default: "#f9f9f9",
        paper: "#ffffff",
      },
      text: {
        primary: "#212121",
        secondary: "#757575",
      },
      status: {
        pending: "#e0e0e0",
        inProgress: "#ffc107",
        future: "#90caf9",
        success: "#4caf50",
        unsuccessful: "#f44336",
        canceled: "#9c27b0",
      },
      messages: {
        client: "#9e9e9e", // Cinza neutro escuro (maior destaque)
        user: "#b3b3b3",   // Cinza mais claro
        others: "#cccccc", // Cinza muito claro
        notes: "#f5f5f5",  // Cinza muito claro
      },
    },
  },
  tropical: {
    palette: {
      mode: "light",
      primary: {
        main: "#4caf50",
      },
      secondary: {
        main: "#ff5722",
      },
      background: {
        default: "#e8f5e9",
        paper: "#ffffff",
      },
      text: {
        primary: "#1b5e20",
        secondary: "#4e342e",
      },
      status: {
        pending: "#c8e6c9",
        inProgress: "#ffe082",
        future: "#80deea",
        success: "#66bb6a",
        unsuccessful: "#f44336",
        canceled: "#ba68c8",
      },
      messages: {
        client: "#4caf50", // Verde vibrante (maior destaque)
        user: "#7ad87c",   // Verde mais claro
        others: "#acf1ae", // Verde muito claro
        notes: "#f2f7ef",  // Verde neutro muito claro
      },
    },
  },
  allBlack: {
    palette: {
      mode: "dark",
      primary: {
        main: "#B3B3B3",
        contrastText: "#0A0A0A",
      },
      secondary: {
        main: "#1A1A1A", // Preto suave
      },
      background: {
        default: "#000000", // Preto absoluto
        paper: "#0A0A0A",   // Fundo para elementos de papel
        chat: "#0E0E0E",    // Fundo das mensagens
      },
      text: {
        primary: "#B3B3B3", // Cinza claro para textos principais
        secondary: "#8C8C8C", // Cinza médio para textos secundários
        disabled: "#666666", // Cinza escuro para textos desabilitados
        hint: "#4D4D4D",     // Cinza suave para placeholders e dicas
      },
      status: {
        pending: "#333333",     // Cinza muito escuro
        inProgress: "#444444",  // Cinza escuro
        future: "#555555",      // Cinza médio
        success: "#3A3A3A",     // Cinza verde escuro para status de sucesso
        unsuccessful: "#4A3A3A", // Cinza avermelhado para erros
        canceled: "#40334D",    // Cinza roxo para cancelados
      },
      messages: {
        client: "#121212", // Preto suave para mensagens do cliente
        user: "#0D0D0D",   // Preto mais escuro para mensagens do usuário
        others: "#1A1A1A", // Preto com leve contraste para mensagens de terceiros
        notes: "#1A1A1A",  // Preto uniforme para notas
      },
      buttons: {
        default: "#1A1A1A", // Preto suave para botões
        hover: "#2B2B2B",   // Cinza muito escuro no hover
        text: "#B3B3B3",    // Texto cinza claro nos botões
      },
      icons: {
        default: "#8C8C8C", // Ícones em cinza médio
        active: "#B3B3B3",  // Ícones ativos em cinza claro
      },
      input: {
        background: "#121212", // Fundo preto suave para campos de entrada
        border: "#2A2A2A",     // Bordas cinza escuro
        hover: "#333333",      // Bordas mais claras no hover
        text: "#B3B3B3",       // Texto cinza claro nos campos
        placeholder: "#666666", // Placeholder em cinza médio
      },
      divider: "#1A1A1A", // Divisores discretos em preto suave
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: "#1A1A1A", // Fundo preto suave
            color: "#B3B3B3",           // Texto cinza claro
            "&:hover": {
              backgroundColor: "#2B2B2B", // Cinza muito escuro no hover
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            color: "#8C8C8C", // Ícones em cinza médio
            "&:hover": {
              color: "#B3B3B3", // Cinza claro no hover
            },
          },
        },
      },
      // MuiInputBase: {
      //   styleOverrides: {
      //     root: {
      //       backgroundColor: "#00000", // Fundo preto suave
      //       color: "#B3B3B3",           // Texto cinza claro
      //     },
      //   },
      // },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: "#1A1A1A", // Fundo preto suave
            color: "#B3B3B3",           // Texto cinza claro
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: "#0A0A0A", // Fundo preto absoluto para o drawer
            color: "#B3B3B3",           // Texto cinza claro
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            backgroundColor: "#1A1A1A", // Fundo preto suave
            color: "#B3B3B3",           // Texto cinza claro nos tabs
          },
          indicator: {
            backgroundColor: "#666666", // Indicador em cinza médio
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            backgroundColor: "#1A1A1A", // Fundo preto suave para itens de lista
            color: "#B3B3B3",           // Texto cinza claro
            "&:hover": {
              backgroundColor: "#2B2B2B", // Cinza muito escuro no hover
            },
          },
        },
      },
    },
  },
  scaniaLight: {
    palette: {
      mode: "light",
      primary: {
        main: "#041E42",
        dark: "#0B2D63",
        light: "#87A0C6",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#6C7A89",
        dark: "#4F5A66",
        light: "#A9B4BF",
        contrastText: "#FFFFFF",
      },
      background: {
        default: "#F5F7FA",
        paper: "#FFFFFF",
        chat: "#F2F5F9",
      },
      text: {
        primary: "#041E42",
        secondary: "#4A5B70",
        disabled: "#98A6B8",
      },
      divider: "#E3E8EF",
      status: {
        pending: "#C7D3E8",
        inProgress: "#FFCA28",
        future: "#A4B9DB",
        success: "#2E7D32",
        unsuccessful: "#D32F2F",
        canceled: "#7E57C2",
      },
      messages: {
        client: "#041E42",
        clientContrast: "#E6EEF8",
        user: "#1A3E7A",
        userContrast: "#FFFFFF",
        others: "#C7D3E8",
        othersContrast: "#041E42",
        notes: "#F4F6F8",
      },
      buttons: {
        default: "#041E42",
        hover: "#0B2D63",
        text: "#FFFFFF",
      },
      input: {
        background: "#FFFFFF",
        border: "#D6DFEA",
        hover: "#C9D5E7",
        text: "#1E2A3A",
        placeholder: "#7C8DA4",
      },
      icons: {
        default: "#6B7C93",
        active: "#041E42",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            textTransform: "none",
            fontWeight: 600,
          },
          containedPrimary: {
            backgroundColor: "#041E42",
            color: "#FFFFFF",
            "&:hover": { backgroundColor: "#0B2D63" },
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          colorPrimary: { backgroundColor: "#041E42" },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: { backgroundColor: "#1B2B47", color: "#E6EEF8" },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: { backgroundColor: "#0F1E36", color: "#E2E8F0" },
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: { backgroundColor: "#041E42" },
        },
      },
    },
    typography: {
      fontFamily: [
        '"Scania Sans"',
        '"Scania Sans Headline"',
        "Inter",
        "Helvetica",
        "Arial",
        "sans-serif",
      ].join(","),
      h1: { fontWeight: 700 },
      h2: { fontWeight: 700 },
      h3: { fontWeight: 700 },
      button: { fontWeight: 600 },
    },
  },
  scaniaDark: {
    palette: {
      mode: "dark",
      primary: {
        main: "#87A0C6",
        dark: "#1A3E7A",
        light: "#C7D3E8",
        contrastText: "#0A1628",
      },
      secondary: {
        main: "#9FB1C7",
        dark: "#7B8EA5",
        light: "#C7D4E3",
        contrastText: "#0A1628",
      },
      background: {
        default: "#0A1628",
        paper: "#0F1E36",
        chat: "#0D1A30",
      },
      text: {
        primary: "#E6EEF8",
        secondary: "#B8C6D9",
        disabled: "#7E8FA6",
      },
      divider: "#1E3354",
      status: {
        pending: "#2A3D5C",
        inProgress: "#FFB74D",
        future: "#4F6FA0",
        success: "#66BB6A",
        unsuccessful: "#EF5350",
        canceled: "#9FA8DA",
      },
      messages: {
        client: "#12305E",
        user: "#0E2750",
        others: "#102A57",
        notes: "#0F223F",
      },
      buttons: {
        default: "#12305E",
        hover: "#0E2750",
        text: "#E6EEF8",
      },
      icons: {
        default: "#B8C6D9",
        active: "#87A0C6",
      },
      input: {
        background: "#0F223F",
        border: "#1E3354",
        hover: "#28456F",
        text: "#E6EEF8",
        placeholder: "#9CB0CA",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            textTransform: "none",
            fontWeight: 600,
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          colorPrimary: { backgroundColor: "#0F1E36" },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: { backgroundColor: "#0F223F", color: "#E6EEF8" },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: { backgroundColor: "#0A1628", color: "#DCE6F3" },
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: { backgroundColor: "#87A0C6" },
        },
      },
    },
    typography: {
      fontFamily: [
        '"Scania Sans"',
        '"Scania Sans Headline"',
        "Inter",
        "Helvetica",
        "Arial",
        "sans-serif",
      ].join(","),
      h1: { fontWeight: 700 },
      h2: { fontWeight: 700 },
      h3: { fontWeight: 700 },
      button: { fontWeight: 600 },
    },
  },
};
export default themes;
